import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { organizationRouting } from './organization.routing';

import { CommonModule } from '@angular/common';

import { SharedModule } from '../shared/shared.module';

import { DashboardComponent } from './components/dashboard/dashboard.component';
// Domains
import { DomainsComponent } from './components/domains/domains.component';
import { DomainsService } from './components/domains/domains.service';

import { AddNameComponent } from './components/domains/add-name/add-name.component';
// Employees
import { EmployeesComponent } from './components/employees/employees.component';
import { EmployeeService } from './components/employees/employee.service';

import { EmployeeAddComponent } from './components/employees/add/employee-add.component';
import { EmployeeDetailsComponent } from './components/employees/details/employee-details.component';
import { EmployeeEditComponent } from './components/employees/edit/employee-edit.component';
// Organization Details
import { OrganizationDetailsComponent } from './components/organization-details/organization-details.component';
import { OrganizationDetailsService } from './components/organization-details/organization-details.service';
import { OrganizationDetailsEditComponent } from './components/organization-details/organization-details-edit/organization-details-edit.component';
import { UpdatePrintLogoComponent } from './components/organization-details/organization-details-edit/update-print-logo/update-print-logo.component';
import { UpdateBrandedLogoComponent } from './components/organization-details/organization-details-edit/update-branded-logo/update-branded-logo.component';
import { UpdateSmtpComponent } from './components/organization-details/organization-details-edit/update-smtp/update-smtp.component';
//Credit Application
import { CreditInfoComponent } from './components/credit/credit-info/credit-info.component';
import { CreditFormComponent } from './components/credit/credit-form/credit-form.component';
import { CreditService } from './components/credit/credit.service';
import { CreditNotificationComponent } from './components/credit/credit-notification/credit-notification.component';
import { CreditComponent } from './components/credit/credit.component';
import { CreditErrorComponent } from './components/credit/credit-error/credit-error.component';
import { CreditDetailsComponent } from './components/credit/credit-details/credit-details.component';
// Manage addresses
import { AddressEditComponent } from './components/organization-details/organization-details-edit/address/address-edit/address-edit.component';
import { AddressCommonService } from './components/common/services/address-common.service';
import { AddressAddComponent } from './components/organization-details/organization-details-edit/address/address-add/address-add.component';
import { AddressesManageGridComponent } from './components/organization-details/organization-details-edit/address/addresses-manage-grid/addresses-manage-grid.component';
import { AddDomainComponent } from './components/organization-details/organization-details-edit/add-domain/add-domain.component';
import { PhoneNumbersComponent } from './components/common/phone-numbers/phone-numbers.component';
import { AddressFormComponentComponent } from './components/common/address-form-component/address-form-component.component';
import { UpdateCertificateSignatoriesComponent } from 'app/organization/components/organization-details/organization-details-edit/update-certificate-signatories/update-certificate-signatories.component';
import { PreviewCertificateComponent } from 'app/shared/components/preview-certificate/preview-certificate.component';
import { CommunicationDashboardComponent } from './components/communication/components/dashboard/dashboard.component';
import { SolarEmailsComponent } from './components/communication/emails/components/emails.component';
import { SolarEmailDetailsComponent } from './components/communication/emails/components/details/email-details.component';
import { TemplatesComponent } from './components/communication/templates/components/templates.component';
import { CreateTemplateComponent } from './components/communication/templates/components/create/create-template.component';
import { SelectTypeComponent } from './components/communication/templates/components/select-type/select-type.component';
import { SolarEmailService } from './components/communication/emails/service/emails.service';
import { TemplatesService } from './components/communication/templates/services/templates.service';
import { FormService } from '../shared/components/form/form.service';
import { TemplateCommonModule } from '../common/template/templateCommon.module';
import { VenuesModule } from './components/venues/venues.module';
import { EmployeeAddInstructorComponent } from './components/employees/add-instructor/employee-add-instructor.component';
import { UpdateBackgroundImageComponent } from './components/organization-details/organization-details-edit/update-background-image/update-background-image.component';
import { ApprovalsDashboardComponent } from './components/approvals/dashboard/approvals-dashboard.component';
import { ApprovedRulesComponent } from './components/approvals/approved-rules/approved-rules.component';
import { TransactionApprovalsComponent } from './components/approvals/transacion-aprovals/transacion-aprovals.component';
import { ApprovalsService } from './components/approvals/approvals.service';
import { CreateApprovalGroupComponent } from './components/approvals/create-approval-group/create-approval-group.component';
import { CreateApprovalRuleComponent } from './components/approvals/create-approval-rule/create-approval-rule.component';
import { OrderDetailsComponent } from './components/approvals/order-details/order-details.component';
import { ApprovalGroupDetailsComponent } from './components/approvals/approval-group-details/approval-group-details.component';
import { RejectPaymentComponent } from './components/approvals/transacion-aprovals/reject-payment/reject-payment.component';
import { ApprovePaymentComponent } from './components/approvals/transacion-aprovals/approve-payment/approve-payment.component';
import { ApprovedTransactionsGridComponent } from './components/approvals/transacion-aprovals/approved-transactions-grid/approved-transactions-grid.component';
import { AwaitingApprovalTransactionsGridComponent } from './components/approvals/transacion-aprovals/awaiting-approval-transactions-grid/awaiting-approval-transactions-grid.component';
import { RejectedTransactionsGridComponent } from './components/approvals/transacion-aprovals/rejected-transactions-grid/rejected-transactions-grid.component';
import { ConsumptionRequestsApprovalsComponent } from './components/approvals/consumption-requests-approvals/consumption-requests-approvals.component';
import { AwaitingApprovalConsumptionRequestsGridComponent } from './components/approvals/consumption-requests-approvals/awaiting-approval-consumption-requests-grid/awaiting-approval-consumption-requests-grid.component';
import { RejectedConsumptionRequestsGridComponent } from './components/approvals/consumption-requests-approvals/rejected-consumption-requests-grid/rejected-consumption-requests-grid.component';
import { ApprovedConsumptionRequestsGridComponent } from './components/approvals/consumption-requests-approvals/approved-consumption-requests-grid/approved-consumption-requests-grid.component';
import { RejectConsumptionRequestModalComponent } from './components/approvals/consumption-requests-approvals/reject-consumption-request-modal/reject-consumption-request-modal.component';
import { ApproveConsumptionRequestModalComponent } from './components/approvals/consumption-requests-approvals/approve-consumption-request-modal/approve-consumption-request-modal.component';
import {CertificatesModule} from './components/certificates/certificates.module';
import { RegisterService } from 'app/phoenix2/register/components/register/register.service';

// Common

@NgModule({
    imports: [
        FormsModule,
        ReactiveFormsModule,
        organizationRouting,
        CommonModule,
        SharedModule,
        TemplateCommonModule,
        VenuesModule,
        CertificatesModule
    ],
    declarations: [
        DashboardComponent,

        EmployeesComponent,
        EmployeeAddComponent,
        EmployeeDetailsComponent,
        EmployeeEditComponent,
        EmployeeAddInstructorComponent,

        DomainsComponent,
        AddNameComponent,

        OrganizationDetailsEditComponent,
        OrganizationDetailsComponent,
        UpdatePrintLogoComponent,
        UpdateBrandedLogoComponent,
        UpdateSmtpComponent,

        CreditInfoComponent,
        CreditFormComponent,
        CreditNotificationComponent,
        CreditComponent,
        CreditErrorComponent,
        CreditDetailsComponent,
        AddressEditComponent,
        AddressFormComponentComponent,
        AddressAddComponent,
        AddressesManageGridComponent,
        AddDomainComponent,
        PhoneNumbersComponent,
        UpdateCertificateSignatoriesComponent,

        CommunicationDashboardComponent,
        SolarEmailsComponent,
        SolarEmailDetailsComponent,
        TemplatesComponent,
        CreateTemplateComponent,
        SelectTypeComponent,
        UpdateBackgroundImageComponent,

        ApprovalsDashboardComponent,
        ApprovedRulesComponent,
        TransactionApprovalsComponent,
        ConsumptionRequestsApprovalsComponent,
        CreateApprovalGroupComponent,
        CreateApprovalRuleComponent,
        OrderDetailsComponent,
        ApprovalGroupDetailsComponent,
        RejectPaymentComponent,
        ApprovePaymentComponent,
        ApprovedTransactionsGridComponent,
        AwaitingApprovalTransactionsGridComponent,
        RejectedTransactionsGridComponent,
        AwaitingApprovalConsumptionRequestsGridComponent,
        RejectedConsumptionRequestsGridComponent,
        ApprovedConsumptionRequestsGridComponent,
        RejectConsumptionRequestModalComponent,
        ApproveConsumptionRequestModalComponent
    ],
    entryComponents: [
        AddressEditComponent,
        AddressAddComponent,
        AddressesManageGridComponent,
        AddDomainComponent,
        PreviewCertificateComponent,
        SelectTypeComponent,
        CreateApprovalGroupComponent,
        CreateApprovalRuleComponent,
        OrderDetailsComponent,
        ApprovalGroupDetailsComponent,
        RejectPaymentComponent,
        ApprovePaymentComponent,
        RejectConsumptionRequestModalComponent,
        ApproveConsumptionRequestModalComponent
    ],
    providers: [
        DomainsService,
        EmployeeService,
        OrganizationDetailsService,
        CreditService,
        AddressCommonService,
        FormService,
        SolarEmailService,
        TemplatesService,
        ApprovalsService,
        RegisterService
    ],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA
    ]
})

export class OrganizationModule { }



// WEBPACK FOOTER //
// ./src/app/organization/organization.module.ts